<template>
  <div class="global-body-style">
    <div class="b-conditions-style">
      <div class="b-con-form">
        <label class="c-label">角色</label>
        <role-auto-complete class="b-con-filter-area" v-model="condition.id" placeholder="请选择" />
      </div>
      <div class="b-con-form">
        <label class="c-label">是否启用</label>
        <el-select class="b-con-filter-area" v-model="condition.status" clearable>
          <el-option value="" label="全部"></el-option>
          <el-option v-for="(status, key) in options.admin_status" :key="key" :value="key" :label="status"></el-option>
        </el-select>
      </div>
      <div class="c-con-search-btn">
        <button class="global-btn primary size-1" @click="search">搜索</button>
        <button class="global-btn info-round size-1" @click="resetEvent">重置</button></button>
      </div>
      <a class="operate-menu" @click="open()" v-permission="'company.role.add'" v-if="userInfo.is_no_secret_login != 1">
        <i class="iconfont iconxinzeng"></i>
        <span>新增</span>
      </a>
    </div>
    <cu-table :data="list" :pageData="condition" @currentChange="currentChange" :isLoading="isLoading">
      <el-table-column label="角色名称" min-width="120">
        <template slot-scope="scope" >
          {{scope.row.name || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="角色描述" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.company_id == 0">系统默认角色不可关闭</span>
          <template v-else>
            <el-tooltip class="item" effect="dark" placement="top-start" popper-class="custome-tooltip" v-if="!!scope.row.description">
              <div slot="content" class="data-list">
                <p>{{scope.row.description}}</p>
              </div>
              <div class="apply-remark">{{scope.row.description || '--'}}</div>
            </el-tooltip>
            <div class="apply-remark" v-else>{{scope.row.description || '--'}}</div>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="人员数量" min-width="90">
        <template slot-scope="scope">
          {{scope.row.admin_count || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="是否启用">
        <template slot-scope="scope">
          <el-switch :disabled="scope.row. company_id=== 0 && userInfo.is_no_secret_login == 1" v-model="scope.row.status" :active-value="1" :inactive-value="2" active-color="#25a0ff" inactive-color="#bfbfbf" @change="e => statusChange(scope.row, e)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="创建人" min-width="120">
        <template slot-scope="scope">
          {{scope.row.creator_name || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.updated_at || '--'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240" fixed="right">
        <template slot-scope="scope" >
          <div class="table-operation">
            <a class="ope-item" @click="copy(scope.row)" v-permission="'company.role.add'" v-if="userInfo.is_no_secret_login != 1">复制</a>
            <a class="ope-item" @click="open(scope.row)" v-if="scope.row.company_id !== 0 && userInfo.is_no_secret_login != 1" v-permission="'company.role.edit'">编辑</a>
            <template>
              <a class="ope-item" @click="detail(scope.row)" v-if="userInfo.is_no_secret_login == 1">权限配置 </a>
              <a class="ope-item" @click="detail(scope.row)" v-permission="'company.role.permission-edit'" v-else>权限配置 </a>
            </template>
            <!-- <a class="ope-item" @click="roleConfig(scope.row)">消息配置 </a> -->
            <a class="ope-item" @click="remove(scope.row, scope.$index)" v-if="scope.row.company_id !== 0 && userInfo.is_no_secret_login != 1" v-permission="'company.role.delete'">删除</a>
          </div>
        </template>
      </el-table-column>
    </cu-table>
    <!-- 添加/编辑 -->
    <firm-role-add ref="firmRoleAddRef" />
    <!-- 详情 -->
    <firm-role-detail ref="firmRoleDetailRef" @initList='initList' />
    <ConfigRole ref="roleConfig" />
  </div>
</template>
<script>
import {configKeys} from '@/setting/index';
import {getRoleList, deleteRole, changeRoleStatus, copyRoleById} from '@/api/firm';
import {validateMobileReg} from '@/utils/validate';
import CuTable from '@/components/cTable';
import { mapState } from 'vuex';
export default {
  name: 'FirmRoleList',
  components: {
    CuTable,
    DepartmentTreeSelect: resolve=>(require(["@/components/select/DepartmentTreeSelect"],resolve)),
    RoleAutoComplete: resolve=>(require(["@/components/select/RoleAutoComplete"],resolve)),
    FirmRoleAdd: resolve=>(require(["./add"],resolve)),
    FirmRoleDetail: resolve=>(require(["./detail"],resolve)),
    TableComponent: resolve=>(require(["@/components/table/index"],resolve)),
    ConditionCompo: resolve=>(require(["@/components/condition/index"],resolve)),
    ConfigRole: resolve=>(require(["./component/config"],resolve)),
  },
  data () {
    return {
      list: [],
      options: {},
      condition: {
        page: 1,
        per_page: 20,
        total: 0,
        id: '',
        status: ''
      },
      activeValue: -1,
      inActiveValue: -1,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
    })
  },
  async mounted () {
    this.options = await this.$store.dispatch('initConfig', [configKeys.admin_status]);
    this.initList();
  },
  methods: {
    // 分页回调
    currentChange (page) {
      this.$set(this.condition, 'page', page);
      this.initList();
    },
    search () {
      this.currentChange(1);
    },
    resetEvent () {
      this.condition= {
        page: 1,
        per_page: 20,
        total: 0,
        name: '',
        status: ''
      }
      this.initList();
    },
    // 初始化角色列表
    async initList () {
      this.isLoading = true;
      try {
        const res = await getRoleList(this.condition);
        this.list = res.data || [];
        this.$set(this.condition, 'total', res.total);
      } catch (error) {
        this.$message.error(error.msg || '获取角色列表出现错误');
      } finally {
        this.isLoading = false;
      }
    },
    copy (row) {
      this.$confirm('确认复制该角色？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        try {
          await copyRoleById({id: row.id});
          this.initList();
          this.$message.success('复制操作成功');
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(_ => {})
    },
    // 删除角色
    remove (row, index) {
      this.$confirm('删除角色操作不可恢复，确认删除该角色？', '删除提示', {
        customClass: 'custom-delete-dialog'
      }).then(async () => {
        try {
          await deleteRole(row.id);
          this.list.splice(index, 1);
          this.$message.success('删除操作成功');
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(e => {})
    },
    // 修改角色状态
    statusChange (row, status) {
      this.$confirm(status === 1 ? '确认启用该角色？' : '禁用后该角色不可再新增绑定人员，已绑定人员不受影响，确认禁用该角色？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async () => {
        try {
          const res = await changeRoleStatus(row.id);
          this.$message.success('操作成功');
          this.initList();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
          row.status = row.status === 1 ? 2 : 1;
        }
      }).catch(() => {
        row.status = row.status === 1 ? 2 : 1;
      })
    },
    open (row) {
      this.$refs.firmRoleAddRef && this.$refs.firmRoleAddRef.open(row);
    },
    detail (row) {
      this.$refs.firmRoleDetailRef && this.$refs.firmRoleDetailRef.open(row);
    },
    roleConfig (row) {
      this.$refs?.roleConfig?.open?.(row.id);
    }
  }
}
</script>
<style lang="less">
@import url('~@/assets/style/base/condition.less');
</style>